import { render, staticRenderFns } from "./new_feature_content.vue?vue&type=template&id=6a22629f&scoped=true&"
import script from "./new_feature_content.vue?vue&type=script&lang=js&"
export * from "./new_feature_content.vue?vue&type=script&lang=js&"
import style0 from "./new_feature_content.vue?vue&type=style&index=0&id=6a22629f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22629f",
  null
  
)

export default component.exports